const debug = false;

// SVG ICONS
const defaultIconSvg = `<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 23.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve"><style type="text/css">	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;stroke:#3283CB;stroke-width:2;stroke-miterlimit:10;}</style><title>quadrato copy@1x</title><circle class="st0" cx="5" cy="5" r="3.8"/></svg>`;
const defaultIcon = new Image();
defaultIcon.src = 'data:image/svg+xml;base64,' + window.btoa(defaultIconSvg);
defaultIcon.width = 10;
defaultIcon.height = 10;

        // SYS ICON
        const sysIconSvg = `<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <title>rombo copy@1x</title>    <g id="rombo-copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <rect id="Rectangle" fill="#0085E4" transform="translate(4.949747, 4.949747) rotate(-45.000000) translate(-4.949747, -4.949747) " x="1.44974747" y="1.44974747" width="7" height="7"></rect>    </g></svg>`;
        const sysIconAlertSvg = `<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <title>rombo@1x</title>    <g id="rombo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <rect id="Rectangle" fill="#FF5E00" transform="translate(4.949747, 4.949747) rotate(-45.000000) translate(-4.949747, -4.949747) " x="1.44974747" y="1.44974747" width="7" height="7"></rect>    </g></svg>`;
        const sysIcon = new Image();
        const sysIconAlert = new Image();
        //sysIcon.src ='/assets/icons/sysIcon.png';
        //sysIconAlert.src ='/assets/icons/sysIconAlert.svg';
        sysIcon.src = 'data:image/svg+xml;base64,' + window.btoa(sysIconSvg);
        sysIconAlert.src = 'data:image/svg+xml;base64,' + window.btoa(sysIconAlertSvg);
        sysIcon.width = 10;
        sysIcon.height = 10;
        sysIconAlert.width = 10;
        sysIconAlert.height = 10;

        // DIA ICON
        const diaIconSvg = `<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <title>quadrato copy@1x</title>    <g id="quadrato-copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect id="Rectangle" fill="#0CCBFA" x="0" y="0" width="10" height="10"></rect></g></svg>`;
        const diaIconAlertSvg = `<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <title>quadrato@1x</title>    <g id="quadrato" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect id="Rectangle" fill="#FF5E00" x="0" y="0" width="10" height="10"></rect></g></svg>`;
        const diaIcon = new Image();
        const diaIconAlert = new Image();
        //diaIcon.src ='/assets/icons/diaIcon.svg';
        //diaIconAlert.src ='/assets/icons/diaIconAlert.svg';
        diaIcon.src ='data:image/svg+xml;base64,' + window.btoa(diaIconSvg);
        diaIconAlert.src ='data:image/svg+xml;base64,' + window.btoa(diaIconAlertSvg);
        diaIcon.width = 10;
        diaIcon.height = 10;
        diaIconAlert.width = 10;
        diaIconAlert.height = 10;

        // BPM ICON
        const bpmIconSvg = `<svg version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve"> <style type="text/css">   .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF3F73;}   </style>   <title>cerchio@1x</title>   <g id="cerchio">   <circle id="Oval" class="st0" cx="5" cy="5" r="5"/>   </g>   </svg>   `;
        const bpmIconAlertSvg = `<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">    <title>cerchio@1x</title>    <g id="cerchio" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">        <circle id="Oval" fill="#FF5E00" cx="5" cy="5" r="5"></circle>    </g></svg>`;
        const bpmIcon = new Image();
        const bpmIconAlert = new Image();
        bpmIcon.src = 'data:image/svg+xml;base64,' + window.btoa(bpmIconSvg);
        bpmIconAlert.src = 'data:image/svg+xml;base64,' + window.btoa(bpmIconAlertSvg);
        bpmIcon.width = 10;
        bpmIcon.height = 10;
        bpmIconAlert.width = 10;
        bpmIconAlert.height = 10;

class SphygmomanometerChart {

    constructor(el, options) {
        if(debug) {
            console.log('SphygmomanometerChart: init in element with id \''+el+'\'', options);
        }

        this.container = document.getElementById(el);
        if(!this.container) {
            console.error('SphygmomanometerChart: element with id \''+el+'\' not found', this.container);
            return;
        }

        this.options = options;

        const { data = [], fromDate, toDate, animation = true, showLine = false, fill = false } = options;

        this.fromDate = new Date(fromDate ?? '');
        this.toDate = new Date(toDate ?? '');

        this.showSys = true; // Imposta la visibilità dei SYS, default: true
        this.showDia = true; // Imposta la visibilità dei DIA, default: true
        this.showBpm = true; // Imposta la visibilità dei BPM, default: true


        // console.debug(fromDate, toDate, this.fromDate, this.toDate, this.fromDate.getTime(), this.toDate.getTime())

        this.container.className = "chart-container";
        this.canvas = document.createElement("canvas");
        this.canvas.id = el+'_canvas';
        // this.canvas.height = this.maxY * 6.5;
        // this.canvas.style = "margin-right: 45px;";

        var ctx = this.canvas.getContext("2d");

        // COLORS

        const color1 = 'rgb(0, 133, 228)';
        const color1Op = 'rgba(0, 133, 228, 0.2)';
        const color1Tr = 'rgba(0, 133, 228, 0)';
        const color1Ov = 'rgb(227, 60, 60)';
        const colorSogliaSYS = 'rgb(0, 133, 228, 1)';

        var backgroundGradient1 = ctx.createLinearGradient(0, 0, 0, 450);
        backgroundGradient1.addColorStop(0.7, color1Tr);
        backgroundGradient1.addColorStop(0, color1Op);

        const color2 = 'rgb(50, 183, 278)';
        const color2Op = 'rgba(50, 183, 278, 0.2)';
        const color2Tr = 'rgba(50, 183, 278, 0)';
        const color2Ov = 'rgb(227, 60, 60)';
        const colorSogliaDIA = 'rgb(50, 183, 278, 0.7)';

        var backgroundGradient2 = ctx.createLinearGradient(0, 0, 0, 450);
        backgroundGradient2.addColorStop(0.7, color2Tr);
        backgroundGradient2.addColorStop(0, color2Op);

        //const color3 = 'rgb(227, 132, 0)';
        const colorBPM = 'rgb(204, 67, 113)';
        const colorAlert = 'rgb(227, 60, 60)';
        const color3Op = 'rgba(227, 132, 0, 0.2)';
        const color3Tr = 'rgba(227, 132, 0, 0)';
        const colorSogliaBPM = 'rgb(204, 67, 113, 0.5)';

        var backgroundGradient3 = ctx.createLinearGradient(0, 0, 0, 450);
        backgroundGradient3.addColorStop(0.7, color3Tr);
        backgroundGradient3.addColorStop(0, color3Op);

        this.container.appendChild(this.canvas);

        if(debug) {
            console.debug('sphygmomanometer data', data);
        }

        this.convertData(data);

        // Setta le caratteristiche del grafico e i dati da visualizzare ( data: this.data1,)
        this.chart = new Chart(this.canvas.id, {
            type: 'line',
            data: {
                labels: this.getLabels(),// this.labels,
                datasets: [{
                    borderColor: (data) => {
                        if((data.type == 'data') &&  (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.pasMinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.pasMinValue))  ||
                                (this.options?.thresholds?.pasMaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.pasMaxValue))
                             ) {
                                return color1Ov;
                            }
                        }

                        return color1;
                    },
                    borderWidth: 2,
                    radius: 3,
                    pointBackgroundColor: 'white',
                    data: this.data1,
                    backgroundColor: backgroundGradient1,
                    tension: 0,
                    // pointHoverBorderWidth: 0,
                    yAxisID: 'y1',
                    fill,
                    showLine,

                    pointStyle: (data) => {
                        if((data.type == 'data') &&  (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.pasMinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.pasMinValue))  || 
                                (this.options?.thresholds?.pasMaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.pasMaxValue)) 
                            ) {
                                return [sysIconAlert];
                            }
                        }
                        return [sysIcon];
                      },
                },{
                    borderColor: (data) => {
                        if((data.type == 'data') &&  (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.padMinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.padMinValue))  ||
                                (this.options?.thresholds?.padMaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.padMaxValue))
                            ) {
                                return color2Ov;
                            }
                        }

                        return color2;
                    },
                    borderWidth: 2,
                    radius: 3,
                    pointBackgroundColor: 'white',
                    data: this.data2,
                    backgroundColor: backgroundGradient2,
                    tension: 0,
                    // pointHoverBorderWidth: 0,
                    yAxisID: 'y1',
                    fill,
                    showLine,

                    pointStyle: (data) => {
                        if((data.type == 'data') && (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.padMinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.padMinValue))  || 
                                (this.options?.thresholds?.padMaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.padMaxValue)) 
                            ) {
                                return [diaIconAlert];
                            }
                        }
                        return [diaIcon];
                      },
                },{
                    borderColor: (data) => {
                        if((data.type == 'data') &&  (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.bpmMinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.bpmMinValue)) || 
                                (this.options?.thresholds?.bpmMaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.bpmMaxValue)) 
                            ){
                                return colorAlert;
                            }
                        }
                        return colorBPM;
                    },
                    borderWidth: 2,
                    radius: 3,
                    pointBackgroundColor: 'white',
                    data: this.data3,
                    backgroundColor: backgroundGradient3,
                    tension: 0,
                    // pointHoverBorderWidth: 0,
                    yAxisID: 'y2',
                    fill,
                    showLine,

                    pointStyle: (data) => {
                        if((data.type == 'data') && (this.options?.thresholds?.enabled_threshold == 1)) {
                            if(
                                (this.options?.thresholds?.bpmMinValue && parseFloat(data.raw?.y) < parseFloat(this.options.thresholds.bpmMinValue)) || 
                                (this.options?.thresholds?.bpmMaxValue && parseFloat(data.raw?.y) > parseFloat(this.options.thresholds.bpmMaxValue)) 
                            ) {
                                return [bpmIconAlert];
                            }
                        }
                        return [bpmIcon];
                      },
                }
                ],
                thresholdsSphyg: [
                    [this.options?.thresholds?.pasMinValue, colorSogliaSYS, this.options?.thresholds?.enabled_threshold, true],
                    [this.options?.thresholds?.pasMaxValue, colorSogliaSYS, this.options?.thresholds?.enabled_threshold, true],
                    [this.options?.thresholds?.padMinValue, colorSogliaDIA, this.options?.thresholds?.enabled_threshold, true],
                    [this.options?.thresholds?.padMaxValue, colorSogliaDIA, this.options?.thresholds?.enabled_threshold, true],
                    [this.options?.thresholds?.bpmMinValue, colorSogliaBPM, this.options?.thresholds?.enabled_threshold, true],
                    [this.options?.thresholds?.bpmMaxValue, colorSogliaBPM, this.options?.thresholds?.enabled_threshold, true],
                ],
            },
            options: {
                layout: {
                    padding: {
                        top: 25,
                    //     left: -10,
                    //     bottom: -10
                    }
                },
                animation: animation,
                interaction: {
                    intersect: false,
                    //mode: 'index'
                    axis: 'xy',
                    mode: 'point',
                },
                plugins: {
                    legend: false,
                    tooltip: {
                        displayColors: false,
                        position: 'nearest',
                        callbacks: {
                            title: function(tooltipItems) {
                                return moment(tooltipItems[0].raw.x).format('DD/MM/YYYY HH:mm');
                            },
                            label: function(tooltipItem) {
                                //return '';
                                return tooltipItem.dataset.mylabel+": "+tooltipItem.raw.y;

                            },
                            footer: (tooltipItems) => {
                                var text = '';
/*
                                if(!!tooltipItems[0] && !!tooltipItems[0].raw) {
                                    text += 'SYS: '+tooltipItems[0].raw.y;
                                }

                                if(!!tooltipItems[1] && !!tooltipItems[1].raw) {
                                    text += '\nDIA: '+tooltipItems[1].raw.y;
                                }

                                if(!!tooltipItems[2] && !!tooltipItems[2].raw) {
                                    text += '\nbpm: ' + tooltipItems[2].raw.y;
                                }
*/
                                return text;
                            }
                        }
                    },
                },
                scales: {
                    x: {
                        type: 'linear',
                        min: this.fromDate ? this.fromDate.getTime() : null,
                        max: this.toDate ? this.toDate.getTime() :  null,
                        grid: {
                            borderWidth: 0,
                            color: function(line) {
                                return false;
                            }
                        },
                        ticks: {
                            display: true,
                            stepSize: this.getStepSize(),
                            // color: '#999',
                            font: {
                                size: 12,
                            },
                            callback: (val, index) => {
                                // Hide the label of every 2nd dataset
                                // return index % 2 === 0 ? moment(this.getLabelForValue(val)).format('DD/MM HH:mm') : '';

                                return this.labels ? moment(val).format(this.getLabelFormat()) : null;
                            },
                        },
                    },
                    y1: {
                        type: 'linear',
                        // position: 'left',
                        min: 50,
                        max: 160,
                        grid: {
                            borderWidth: 0,
                            borderDash: [4],
                            color: function(line) {
                                return "rgba(75,75,75,0.2)";
                            }
                        },
                        ticks: {
                            display: true, //this will remove only the label
                            stepSize: 10,
                            color: color1,
                            font: {
                                size: 12,
                            },
                            callback: function(value, index) {
                                return value + '  ';
                            }
                        },
                    },
                    y2: {
                        type: 'linear',
                        position: 'right',
                        min: 50,
                        max: 160,
                        grid: {
                          drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                        ticks: {
                            display: true, //this will remove only the label
                            stepSize: 10,
                            //color: color3,
                            color: colorBPM,
                            font: {
                                size: 12,
                            },
                            callback: function(value, index) {
                                return '  ' + value;
                            }
                        }
                    },
                },
                responsive: true,
                maintainAspectRatio: true
            },
            plugins: [
                {
                    afterDatasetDraw: (chart) => {
                        let ctx = chart.ctx;
                        ctx.font = '12px Arial';
                        ctx.textBaseline = 'top';
                        ctx.textAlign = 'left';
                        const iconWidth = 8; // Larghezza dell'icona personalizzata

                        const offsetWidth = ctx.canvas.offsetWidth;

                        // SYS Legend
                        ctx.fillStyle = color1;
                        //this.drawCustomIcon(ctx, '/assets/icons/sysIcon.svg', 16, 0, iconWidth, iconWidth); // Disegna l'icona personalizzata
                        this.drawCustomIcon(ctx, sysIcon.src, 16, 0, iconWidth, iconWidth); // Disegna l'icona personalizzata
                        ctx.fillText('SYS', 20 + iconWidth, 0); // Aggiungi spazio per l'icona

                        // DIA Legend
                        ctx.fillStyle = color2;
                        this.drawCustomIcon(ctx, diaIcon.src, 65, 0, iconWidth, iconWidth); // Disegna l'icona personalizzata
                        ctx.fillText('DIA', 80, 0);

                        // BPM Legend
                        //ctx.fillStyle = color3; // label color
                        ctx.fillStyle = colorBPM; // label color
                        ctx.textAlign = 'right';
                        this.drawCustomIcon(ctx, bpmIcon.src, offsetWidth - 40, 0, iconWidth, iconWidth); // Disegna l'icona personalizzata
                        ctx.fillText('bpm', offsetWidth - 1, 0);
                    }
                }
            ]
        });

        if(debug) {
            console.debug('sphygmomanometer done', this.labels, this.data1, this.data2, this.data3);
        }
    }

    convertData(data) {
        // this.labels = [];
        this.data1 = [];
        this.data2 = [];
        this.data3 = [];

        if(!!data && !!data.pas) {
            for (const prop in data.pas) {
                // console.log(`${prop} - ${data.pas[prop]}`);
                // this.labels.push(prop);
                let millis = parseInt(prop) * 1000;
                this.data1.push({
                    y: data.pas[prop],
                    x: millis
                });
                this.data2.push({
                    y: data.pad[prop],
                    x: millis
                });
                this.data3.push({
                    y: data.bpm[prop],
                    x: millis
                });
            }
        }

        if(debug) {
            console.debug('sphygmomanometer convertData', this.data1, this.data2, this.data3);
        }

        // if(this.labels.length == 0) {
        //     this.setDefaultLabels()
        // }
    }


    // Metodo per impostare la visibilità dei SYS
    setShowSys(show) {
        this.showSys = show;
        this.chart.data.datasets[0].hidden = !show; // Imposta la visibilità dei SYS
        this.chart.data.thresholdsSphyg[0][2] = show; // Imposta la visibilità della soglia minima dei SYS
        this.chart.data.thresholdsSphyg[1][2] = show; // Imposta la visibilità della soglia massima dei SYS
        this.chart.update();
    }
    // Metodo per impostare la visibilità dei DIA
    setShowDia(show) {
        this.showDia = show;
        this.chart.data.datasets[1].hidden = !show; // Imposta la visibilità dei DIA
        this.chart.data.thresholdsSphyg[2][2] = show; // Imposta la visibilità della soglia minima dei DIA
        this.chart.data.thresholdsSphyg[3][2] = show; // Imposta la visibilità della soglia massima dei DIA
        this.chart.update();
    }

    // Metodo per impostare la visibilità dei BPM
    setShowBpm(show) {
        this.showBpm = show;
        this.chart.data.datasets[2].hidden = !show; // Imposta la visibilità dei BPM
        this.chart.data.thresholdsSphyg[4][2] = show; // Imposta la visibilità della soglia minima dei BPM
        this.chart.data.thresholdsSphyg[5][2] = show; // Imposta la visibilità della soglia massima dei BPM
        this.chart.update();
    }

    setData(data, fromDate, toDate) {
        if(debug) {
            console.debug('sphygmomanometerChart setData', this.chart, this.chart.scales);
        }

        this.fromDate = new Date(fromDate);
        this.toDate = new Date(toDate);

        this.chart.config.options.scales.x.min = this.fromDate.getTime();
        this.chart.config.options.scales.x.max = this.toDate.getTime();
        this.chart.config.options.scales.x.ticks.stepSize = this.getStepSize();

        this.convertData(data);

        this.chart.data.labels = this.getLabels();
        this.chart.data.datasets[0].data = this.data1;
        this.chart.data.datasets[0].mylabel = 'SYS';

        this.chart.data.datasets[1].data = this.data2;
        this.chart.data.datasets[1].mylabel = 'DIA';
        /*
        this.chart.data.datasets[2].data = this.data3;
        this.chart.data.datasets[2].mylabel = 'bpm';
        */
        if (this.showBpm) {
            this.chart.data.datasets[2].data = this.data3;
            this.chart.data.datasets[2].mylabel = 'bpm';
        } else {
            // If showBpm is false, set an empty array for the BPM dataset to hide it
            this.chart.data.datasets[2].data = [];
            this.chart.data.datasets[2].mylabel = '';
        }

        this.chart.update();
    }
    

    getLabels() {
        let date = new Date(this.fromDate);
        let labels = [];
        // let debugs = [];

        while(date <= this.toDate) {
            labels.push(date.getTime());
            // date.setDate(date.getDate() + 1);
            date = new Date(date.getTime() + this.getStepSize());
            // debugs.push(moment(date.getTime()).format('DD/MM/YYYY HH:mm'));
        }

        // console.debug('labels', debugs);
        this.labels = labels;

        return labels;
    }

    getStepSize() {
        // console.debug('getStepSize', this.toDate - this.fromDate > 604800000 ? 86400000 : 14400000);
        return this.toDate - this.fromDate > 604800000 ? 86400000 : 14400000;
    }

    getLabelFormat() {
        // console.debug('getLabelFormat', this.fromDate, this.toDate, this.toDate - this.fromDate, 604800000 + 86400000, this.toDate - this.fromDate > 604800000 + 86400000);
        return this.toDate - this.fromDate > 604800000 + 86400000 ? 'DD/MM/YYYY' : 'DD/MM HH:mm';
    }

    toBase64Image(type, quality) {
        return this.chart.toBase64Image(type, quality);
    }

    // Funzione per disegnare un'icona personalizzata sul canvas
    drawCustomIcon(ctx, iconPath, x, y, width, height) {
        var img = new Image();
        img.src = iconPath;
        ctx.drawImage(img, x, y, width, height);

    }

}



var thresholdPlugin = {
    id: 'thresholdSphyg',
    beforeDraw: function(chart, args) {

        const thresholdsWidth = 10;
        const shiftSoglia = 30;

        if (!chart.config.data.thresholdsSphyg) 
            return;

        // SYS
        let yAxis = chart.scales['y1'];

        // SYS MIN
        if(chart.config.data.thresholdsSphyg[0][0] != undefined && chart.config.data.thresholdsSphyg[0][2] == 1 && yAxis != undefined){
            // console.log('thresholdPlugin', chart.config.data.thresholdsSphyg[0][0]);
            value = chart.config.data.thresholdsSphyg[0];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(shiftSoglia, y);
            chart.ctx.lineTo(shiftSoglia+thresholdsWidth, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

        // SYS MAX
        if(chart.config.data.thresholdsSphyg[1][0] != undefined && chart.config.data.thresholdsSphyg[1][2] == 1 && yAxis != undefined){
            // console.log('thresholdPlugin', chart.config.data.thresholdsSphyg[1][0]);
            value = chart.config.data.thresholdsSphyg[1];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(shiftSoglia, y);
            chart.ctx.lineTo(shiftSoglia+thresholdsWidth, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

        // DIA
        yAxis = chart.scales['y1'];

        // DIA MIN
        if(chart.config.data.thresholdsSphyg[2][0] != undefined && chart.config.data.thresholdsSphyg[2][2] == 1 && yAxis != undefined){
            // console.log('thresholdPlugin', chart.config.data.thresholdsSphyg[2][0]);
            value = chart.config.data.thresholdsSphyg[2];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(shiftSoglia, y);
            chart.ctx.lineTo(shiftSoglia+thresholdsWidth, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }



        // DIA MAX
        if(chart.config.data.thresholdsSphyg[3][0] != undefined && chart.config.data.thresholdsSphyg[3][2] == 1 && yAxis != undefined){
            // console.log('thresholdPlugin', chart.config.data.thresholdsSphyg[3][0]);
            value = chart.config.data.thresholdsSphyg[3];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(shiftSoglia, y);
            chart.ctx.lineTo(shiftSoglia+thresholdsWidth, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

        // BPM
        yAxis = chart.scales['y2'];

        // BPM MIN
        if(chart.config.data.thresholdsSphyg[4][0] != undefined && chart.config.data.thresholdsSphyg[4][2] == 1 && yAxis != undefined){
            value = chart.config.data.thresholdsSphyg[4];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(chart.width - thresholdsWidth - shiftSoglia, y);
            chart.ctx.lineTo(chart.width - shiftSoglia, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

        // BPM MAX
        if(chart.config.data.thresholdsSphyg[5][0] != undefined && chart.config.data.thresholdsSphyg[5][2] == 1 && yAxis != undefined){
            value = chart.config.data.thresholdsSphyg[5];
            let y = yAxis.getPixelForValue(value[0]);
            chart.ctx.beginPath();
            chart.ctx.moveTo(chart.width - thresholdsWidth - shiftSoglia, y);
            chart.ctx.lineTo(chart.width - shiftSoglia, y);
            chart.ctx.lineWidth = 2;
            chart.ctx.strokeStyle = value[1];
            chart.ctx.stroke();
        }

    }
};

// Aggiunge il plugin a Chart.js
Chart.register(thresholdPlugin);

window.SphygmomanometerChart = SphygmomanometerChart;